function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "icon-comments"
}, "Comments Icon-");

var SvgIconComments = function SvgIconComments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "aria-labelledby": "icon-comments",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "icon-comments"
  }, title) : null, React.createElement("path", {
    d: "M40.5,36.67a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,40.5,36.67Zm5,0a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,45.5,36.67Zm-10,0a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,35.5,36.67Zm13.5-7a3,3,0,0,1,3,3v11a3,3,0,0,1-3,3H32.8L29.74,50a1,1,0,0,1-1.42.06,1,1,0,0,1-.32-.74V32.67a3,3,0,0,1,3-3Z",
    style: {
      fillRule: "evenodd"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconComments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-comments.9cad6c37.svg";
export { ForwardRef as ReactComponent };